import * as React from 'react';
import {
    chakra,
    Container,
    Stack,
    HStack,
    Text,
    useColorModeValue,
    Image,
    Skeleton,
    Box,
    Icon
} from '@chakra-ui/react';
// Here we have used react-icons package for the icons
import { MdBook } from 'react-icons/md';
import { Link } from "react-router-dom"

export const Home = () => {
    return (
        <Container
            className='animate__animated animate__fadeIn'
            maxW="6xl"
            px={{ base: 6, md: 3 }}
            py={30}
        >
            <Stack direction={{ base: 'column', md: 'row' }} justifyContent="center">
                <Stack direction="column" spacing={6} justifyContent="center" maxW="480px">
                    <HStack
                        p={1}
                        rounded="full"
                        fontSize="sm"
                        w="max-content"
                        bg={useColorModeValue('gray.300', 'gray.700')}
                    >
                    </HStack>
                    <chakra.h1 fontSize="5xl" lineHeight={1} fontWeight="bold" textAlign="left">
                        Store your favorite websites
                        <br />
                        <chakra.span color="#63b3ed">in Wed-Collections</chakra.span>
                    </chakra.h1>
                    <Text
                        fontSize="1.2rem"
                        textAlign="left"
                        lineHeight="1.375"
                        fontWeight="400"
                        color="gray.500"
                    >
                        start now
                    </Text>
                    <HStack
                        spacing={{ base: 0, sm: 2 }}
                        mb={{ base: '3rem !important', sm: 0 }}
                        flexWrap="wrap"
                    >
                        <Link to="/collections">
                            <chakra.button
                                w={{ base: '100%', sm: 'auto' }}
                                h={12}
                                px={6}
                                color="white"
                                size="lg"
                                rounded="md"
                                mb={{ base: 2, sm: 0 }}
                                zIndex={5}
                                lineHeight={1}
                                bgGradient="linear(to-l, #0ea5e9,#2563eb)"
                                _hover={{ bgGradient: 'linear(to-l, #0ea5e9,#2563eb)', opacity: 0.9 }}
                            >
                                <chakra.span> Explore Collections </chakra.span>
                                <Icon as={MdBook} h={4} w={4} ml={1} />
                            </chakra.button>
                        </Link>
                        <Box
                            d="flex"
                            justifyContent="center"
                            bg={useColorModeValue('white', 'gray.800')}
                            w={{ base: '100%', sm: 'auto' }}
                            maxWidth="50%"
                            textAlign={"center"}
                            border="1px solid"
                            borderColor="gray.300"
                            p={3}
                            lineHeight={1.18}
                            rounded="md"
                            boxShadow="md"
                            zIndex={55555555}
                            cursor="pointer"
                        >
                            New Collection
                        </Box>
                    </HStack>
                </Stack>
                <Box ml={{ base: 0, md: 5 }} pos="relative" className='floating'>
                    <Image
                        w="500px"
                        h="75%"
                        minW={{ base: 'auto', md: '30rem' }}
                        objectFit="cover"
                        src={`/home-image.png`}
                        rounded="md"
                        fallback={<Skeleton />}
                    />
                </Box>
            </Stack>
        </Container>
    );
};

